<template>
  <a-layout-sider :class="[theme, 'sider', isMobile ? null : 'shadow']" width="256px" height="100vh" :collapsible="collapsible" v-model="collapsed" :trigger="null">
    <div :class="['logo', theme]">
<!--      <router-link to="/logManage/LogRecord">-->
        <img src="static/img/logoName.svg">
<!--        <h1>{{systemName}}</h1>-->
<!--      </router-link>-->
    </div>
    <i-menu :theme="theme" :collapsed="collapsed" :menuData="menuData" @select="onSelect"/>
  </a-layout-sider>
</template>

<script>
import IMenu from './menu'
export default {
  name: 'SiderMenu',
  components: {IMenu},
  props: {
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    menuData: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'light'
    }
  },
  computed: {
    isMobile () {
      return this.$store.state.setting.isMobile
    },
    systemName () {
      return this.$store.state.setting.systemName
    }
  },
  methods: {
    onSelect (obj) {
      this.$store.commit('setting/setLastMenu',obj.key);
      this.$emit('menuSelect', obj)
    }
  }
}
</script>

<style lang="less" scoped>
  .shadow{
    box-shadow: 2px 0 6px rgba(0,21,41,.35);
  }
  .sider{
    z-index: 10;
    &.light{
      background-color: #fff;
    }
    &.dark{
      background-color: #001529;
    }
    .logo{
      height: 64px;
      position: relative;
      line-height: 64px;
      padding-left: 24px;
      -webkit-transition: all .3s;
      transition: all .3s;
      overflow: hidden;
      &.light{
        background-color: #fff;
        /*background: -webkit-linear-gradient(left,#00A89C,#58D8CD);*/
        h1{
          color: #1890ff;
          /*color: white;*/
        }
      }
      &.dark{
        background-color: #002140;
        h1{
          color: #fff;
        }
      }
      h1{
        color: #fff;
        font-size: 20px;
        margin: 0 0 0 12px;
        font-family: "Myriad Pro","Helvetica Neue",Arial,Helvetica,sans-serif;
        font-weight: 600;
        display: inline-block;
        height: 32px;
        line-height: 32px;
        vertical-align: middle;
      }
      img{
        /*width: 32px;*/
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
</style>
<style>

</style>



// WEBPACK FOOTER //
// src/components/menu/SiderMenu.vue